import React, { useContext } from "react";
import { Dropdown } from "react-bootstrap";
import NewCampraLogo from "../Img/camptralogo.png";
import { useNavigate } from "react-router-dom";
import back from "../Img/new home.png";
import AdminImg from "../Img/usrpict.PNG";
import Viewer from "../Img/user_8777874.png";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { useState } from "react";
import GlobalContext from "../context/GlobalContext";
import logo from "../Img/white logo-2.png";
import AiChat from "../Img/AI-chat.png";
import TanentUser from "../Img/tanent-users.png";
import DasboardImg from "../Img/dasboard.png";
const InnerHamburgerNavigation = () => {
  const [isCollapse, setIsCollapse] = useState(false);

  const navigate = useNavigate();
  const rolles = localStorage.getItem("roles");
  const logOutBtn = () => {
    localStorage.removeItem("jwt_token");
    localStorage.removeItem("tags");
    navigate("/");
  };

  const {
    logoutModal,
    setLogoutModal,
    setSettingsDropdown,
    settingsDropdown,
    setINHumberger,
    INHumberger,
  } = useContext(GlobalContext);

  const backBtn = () => {
    navigate("/table-posts");
  };
  const uploadUsers = () => {
    navigate("/create-new-user-form");
  };
  const HomeBtn = () => {
    localStorage.removeItem("catagoryId");
    navigate("/all-articles");
  };

  const onclickHandler = () => {
    setINHumberger(true);
    // setTopHumberger(false)
  };
  const chatModalOpen = () => {
    navigate("/analytics-dashboard");
  };
  return (
    <nav className="navbar navbar-expand-lg bg-dark navbar-dark w-100 inner-hamburger">
      <div className="container-fluid">
        {/* <a className="navbar-brand" href="#">Navbar</a> */}
        <img src={logo} alt="" srcset="" width={100} />

        <button
          onClick={onclickHandler}
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#inner-hamburger"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className={
            INHumberger == undefined
              ? "collapse navbar-collapse flex-column"
              : !INHumberger
              ? "collapse navbar-collapse flex-column "
              : "collapse navbar-collapse flex-column"
          }
          id="inner-hamburger"
        >
          {/* <ul className="navbar-nav">
          <li className="nav-item">
            <a className="nav-link active" aria-current="page" href="#">Home</a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="#">Features</a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="#">Pricing</a>
          </li>
          <li className="nav-item">
            <a className="nav-link disabled">Disabled</a>
          </li>
        </ul> */}

          <div className="d-flex flex-column align-items-start">
            <div className="back-screen ">
              <button className="text-light" onClick={HomeBtn}>
                Home
              </button>
            </div>
            {rolles == "administrator" && (
              <>
                <div className="back-screen d-flex flex-column align-items-start">
                  <button
                    className="setting-btn text-light"
                    onClick={(e) => {
                      e.stopPropagation();
                      settingsDropdown
                        ? setSettingsDropdown(false)
                        : setSettingsDropdown(true);
                    }}
                  >
                    Settings{" "}
                    {settingsDropdown ? <IoIosArrowUp /> : <IoIosArrowDown />}
                  </button>
                  {settingsDropdown && (
                    <div
                      className="d-flex flex-column align-items-start  rounded text-light"
                      style={{ width: "max-content" }}
                    >
                      <div
                        onClick={() => navigate("/create-new-user-form")}
                        role="button"
                        className="manage-users p-2 rounded "
                      >
                        Manage users
                      </div>
                      <div
                        onClick={() => navigate("/create-subcategory")}
                        role="button"
                        className="manage-users  p-2 rounded "
                      >
                        Manage Categories
                      </div>
                      <div
                        onClick={() => navigate("/create-tag")}
                        role="button"
                        className="manage-users  p-2 rounded "
                      >
                        Manage Tags
                      </div>
                    </div>
                  )}
                </div>
                <div className="back-screen d-flex flex-column align-items-start">
                  <button
                    className="text-light"
                    // type="button" className="btn " data-bs-toggle="tooltip" data-bs-placement="top" title="My Articles"
                    onClick={backBtn}
                  >
                    {/* <img src={myarticles} alt="" style={{ width: '40px', height: '40px' }} /> */}
                    My Articles
                  </button>
                </div>
              </>
            )}
            {rolles == "author" && (
              <>
                <div className="back-screen d-flex flex-column align-items-start">
                  <button
                    className="setting-btn text-light"
                    onClick={(e) => {
                      e.stopPropagation();
                      settingsDropdown
                        ? setSettingsDropdown(false)
                        : setSettingsDropdown(true);
                    }}
                  >
                    Settings{" "}
                    {settingsDropdown ? <IoIosArrowUp /> : <IoIosArrowDown />}
                  </button>
                  {settingsDropdown && (
                    <div
                      className="d-flex flex-column align-items-start  rounded text-light"
                      style={{ width: "max-content" }}
                    >
                      <div
                        onClick={() => navigate("/create-subcategory")}
                        role="button"
                        className="manage-users  p-2 rounded "
                      >
                        Manage Categories
                      </div>
                    </div>
                  )}
                </div>
                <div className="back-screen d-flex flex-column align-items-start">
                  <button
                    className="text-light"
                    // type="button" className="btn " data-bs-toggle="tooltip" data-bs-placement="top" title="My Articles"
                    onClick={backBtn}
                  >
                    {/* <img src={myarticles} alt="" style={{ width: '40px', height: '40px' }} /> */}
                    My Articles
                  </button>
                </div>
              </>
            )}

            {rolles == "editor" && (
              <div className="">
                <div
                  onClick={() => {
                    navigate("/default-page");
                  }}
                  role="button"
                  className="manage-users back-screen rounded "
                >
                  Home
                </div>

                <div className="back-screen ">
                  <button onClick={HomeBtn}>
                    {/* Home */}
                    <img
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Advance Chat"
                      width={40}
                      src={AiChat}
                      alt=""
                    />
                  </button>
                </div>
                <div className="back-screen d-flex flex-column align-items-start">
                  <button
                    className="text-light"
                    // type="button" className="btn " data-bs-toggle="tooltip" data-bs-placement="top" title="My Articles"
                    onClick={backBtn}
                  >
                    {/* <img src={myarticles} alt="" style={{ width: '40px', height: '40px' }} /> */}
                    My Articles
                  </button>
                </div>

                <div
                  onClick={() => navigate("/create-new-user-form")}
                  role="button"
                  className="manage-users p-2 rounded "
                >
                  Manage users
                </div>

                <div className="back-screen ">
                  <button
                    // data-bs-toggle="modal"
                    // data-bs-target="#exampleModal"
                    onClick={chatModalOpen}
                  >
                    AdvanceChat
                    {/* <img data-bs-toggle="tooltip" data-bs-placement="top" title="Dasboard" width={35} src={DasboardImg} alt="" /> */}
                  </button>
                </div>
                <div
                  onClick={() => {
                    navigate("/widget-installation-guide");
                  }}
                  role="button"
                  className="manage-users  p-2 me-2 rounded "
                >
                  <img
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Tenant User"
                    width={35}
                    src={TanentUser}
                    alt=""
                  />
                </div>

                {/* <div className="back-screen notificaion-screen">
                                <button onClick={notifications} className="notification-button">
                                    <img src={NotificationImg} data-bs-toggle="tooltip" data-bs-placement="top" title="Notification" alt="" className="notification-icon" />
                                    {notificationCount > 0 && <div className="notification-count">{notificationCount}</div>}
                                </button>
                            </div> */}
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default InnerHamburgerNavigation;
